/* eslint-disable */
import Vue from "vue";
import ShardsVue from "shards-vue";
import VueAnalytics from "vue-analytics";
// Styles
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/shards-dashboard-pro/shards-dashboards.scss";
import "@/assets/scss/date-range.scss";
import "../node_modules/shepherd.js/dist/css/shepherd.css";
// Core
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 3rd Party Components
import VueTagsInput from "@johmun/vue-tags-input";
// Layouts
import Default from "@/layouts/Default.vue";
import HeaderNavigation from "@/layouts/HeaderNavigation.vue";
import IconSidebar from "@/layouts/IconSidebar.vue";
import Auth from "@/layouts/Auth.vue";
import Docs from "@/layouts/Docs.vue";
import i18n from "./i18n";

//
const isProd = process.env.NODE_ENV === "production";
//
ShardsVue.install(Vue);
Vue.component("vue-tags-input", VueTagsInput);
Vue.component("default-layout", Default);
Vue.component("header-navigation-layout", HeaderNavigation);
Vue.component("auth-layout", Auth);
Vue.component("docs-layout", Docs);
Vue.component("icon-sidebar-layout", IconSidebar);
Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
// Analytics
Vue.use(VueAnalytics, {
  id: isProd ? "UA-115105611-1" : "UA-115105611-2",
  router
});

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
